import { useEffect } from "react";

const BASE = "Brothers Advertising";

export default function usePageTitle(section) {
  useEffect(() => {
    const title = section ? `${section} · ${BASE}` : BASE;
    document.title = title;
    return () => {
      document.title = BASE;
    };
  }, [section]);
}
